
import { useEffect, useState, ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from './utils/supabase'

export default function ProtectedRoute({ children }: { children: ReactNode }) {
  const [loading, setLoading] = useState(true)
  const [authenticated, setAuthenticated] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession()
        
        if (!session) {
          navigate('/')
          return
        }
        
        setAuthenticated(true)
      } catch (error) {
        console.error('Auth check failed:', error)
        navigate('/')
      } finally {
        setLoading(false)
      }
    }
    
    checkAuth()
  }, [navigate])

  if (loading) return <div className="p-6 text-center">Loading…</div>
  if (!authenticated) return null 
  return <>{children}</>
}